import type { CampaignAudienceFilter } from "@/model/interface/Campaign";
import { CampaignTargetType } from "@/enum/CampaignTargetType";

export const HAND_PICKED_AUDIENCE = "HAND_PICKED";

export const AUDIENCE_SOURCE_LABELS: Record<CampaignTargetType, string> = {
  [CampaignTargetType.CONTACT_LIST]: "Contact list",
  [CampaignTargetType.TAG]: "Tag",
  [CampaignTargetType.FILTER]: "Lead filter",
  [CampaignTargetType.SAVED_SEARCH]: "Saved property search",
};

export const EMPTY_AUDIENCE_FILTER: Required<CampaignAudienceFilter> = {
  type: "",
  dealStageIds: [],
  assignedMembershipIds: [],
  dataImportIds: [],
  addedFrom: "",
  addedTo: "",
};

export function parseAudienceFilter(targetRef?: string | null): Required<CampaignAudienceFilter> {
  if (!targetRef) {
    return EMPTY_AUDIENCE_FILTER;
  }
  try {
    const parsed: CampaignAudienceFilter = JSON.parse(targetRef);
    return {
      type: parsed.type ?? "",
      dealStageIds: parsed.dealStageIds ?? [],
      assignedMembershipIds: parsed.assignedMembershipIds ?? [],
      dataImportIds: parsed.dataImportIds ?? [],
      addedFrom: parsed.addedFrom ?? "",
      addedTo: parsed.addedTo ?? "",
    };
  } catch {
    return EMPTY_AUDIENCE_FILTER;
  }
}

export function serializeAudienceFilter(filter: CampaignAudienceFilter): string {
  const cleaned: CampaignAudienceFilter = {
    type: filter.type || undefined,
    dealStageIds: filter.dealStageIds?.length ? filter.dealStageIds : undefined,
    assignedMembershipIds: filter.assignedMembershipIds?.length ? filter.assignedMembershipIds : undefined,
    dataImportIds: filter.dataImportIds?.length ? filter.dataImportIds : undefined,
    addedFrom: filter.addedFrom || undefined,
    addedTo: filter.addedTo || undefined,
  };
  return JSON.stringify(cleaned);
}
